import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bs-divider", { 'bs-divider-h': _ctx.horizontal, 'bs-divider-v': _ctx.vertical }]),
    style: _normalizeStyle({
            'height': _ctx.horizontal ? `${_ctx.thicknessInPx}px` : undefined,
            'width': _ctx.vertical ? `${_ctx.thicknessInPx}px` : undefined
        })
  }, null, 6))
}